import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

const RateLimitErrorBanner = ({ error, onDismiss }) => {
    const [timeRemaining, setTimeRemaining] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (error) {
            // Extract time remaining from error message if present
            const match = error.match(/wait (\d+) seconds/);
            if (match) {
                const seconds = parseInt(match[1], 10);
                setTimeRemaining(seconds);
                setIsVisible(true);
            }
        } else {
            setIsVisible(false);
            setTimeRemaining(null);
        }
    }, [error]);

    useEffect(() => {
        if (!timeRemaining) return;

        const interval = setInterval(() => {
            setTimeRemaining(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    setIsVisible(false);
                    onDismiss();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [timeRemaining, onDismiss]);

    if (!isVisible) return null;

    return (
        <div
            className="fixed top-0 left-0 right-0 bg-red-500 text-white p-4 z-50 transition-opacity duration-300"
            style={{ opacity: isVisible ? 1 : 0 }}
        >
            <div className="container mx-auto flex justify-between items-center">
                <span>
                    {error?.replace(/wait \d+ seconds/, `wait ${timeRemaining} seconds`)}
                </span>
                <button
                    onClick={() => {
                        setIsVisible(false);
                        onDismiss();
                    }}
                    className="text-white hover:text-gray-200"
                    aria-label="Dismiss"
                >
                    <X size={16} />
                </button>
            </div>
        </div>
    );
};

export default RateLimitErrorBanner;